import { fork, put, takeEvery } from 'redux-saga/effects';

import {
    DELETE_SOCIAL_GROUP_RIDE_USER_DATA_SUCCESS,
    DELETE_SOCIAL_GROUP_RIDE_USER_DATA_ERROR,
    FETCH_SOCIAL_GROUP_RIDE,
    DELETE_SOCIAL_GROUP_RIDE_USER_DATA,
    FETCH_SOCIAL_GROUP_RIDE_COMPETITIONS
} from '../actions/ActionTypes';
import { receiveSocialGroupRide, receiveSocialGroupRideCompetitions, receiveSocialGroupRideFailed } from '../actions';
import { fetchMultipleUserSocialProfileImage } from 'actions/userSocialProfileImageActions';
import { gcApi } from '../config/axios';

export function* fetchSocialGroupRide(action) {
    // https://connectapitest-swagger.garmin.com/?urls.primaryName=socialgroupride-service#/SocialGroupRideService/getSocialGroupRideResults
    try {
        let url = `/socialgroupride-service/socialGroupRide/${action.groupRideUUID}`;

        if (action.activityId) {
            url += `?activityId=${action.activityId}`;
        }

        const response = yield gcApi.get(url);

        yield put(receiveSocialGroupRide(response.data));

        yield fork(fetchSocialGroupRideProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put(receiveSocialGroupRideFailed());
    }
}

export function* deleteSocialGroupRideUserData(action) {
    // https://connectapitest-swagger.garmin.com/?urls.primaryName=socialgroupride-service#/SocialGroupRideValidationService/deleteSocialGroupRideData
    try {
        const response = yield gcApi.delete(`/socialgroupride-service/socialGroupRide/${action.groupRideUUID}`);

        yield put({
            type: DELETE_SOCIAL_GROUP_RIDE_USER_DATA_SUCCESS
        });
    } catch (e) {
        yield put({
            type: DELETE_SOCIAL_GROUP_RIDE_USER_DATA_ERROR
        });
    }
}

export function* fetchAllCompetitions(action) {
    // https://connectapitest-swagger.garmin.com/?urls.primaryName=socialgroupride-service#/SocialGroupRideService/getAllSocialGroupRideCompetitionsResults
    try {
        let url = `/socialgroupride-service/socialGroupRide/${action.groupRideUUID}/allCompetitions`;

        if (action.activityId) {
            url += `?activityId=${action.activityId}`;
        }

        const response = yield gcApi.get(url);

        yield put(receiveSocialGroupRideCompetitions(response.data));
        yield fork(fetchAllCompetitionsProfileImageAndFrameSaga, response.data);
    } catch (e) {}
}

/**
 * handle `fetchSocialGroupRide` response
 * @param {Object} responseData
 * @param {Object[]} responseData.groupRideParticipants
 * @param {number} responseData.groupRideParticipants[].userPk
 */
function* fetchSocialGroupRideProfileImageAndFrameSaga(responseData) {
    if (!responseData?.groupRideParticipants?.length) {
        return;
    }
    const userIds = responseData?.groupRideParticipants.map((item) => item.userPk);
    yield fork(fetchProfileImageAndFrameSaga, userIds);
}

/**
 * handle `fetchAllCompetitions` response
 * @param {Object} responseData
 * @param {Object[]} responseData.leaderboards
 * @param {Object[]} responseData.leaderboards[].leaderboard
 * @param {number} responseData.leaderboards[].leaderboard[].userPk
 */
function* fetchAllCompetitionsProfileImageAndFrameSaga(responseData) {
    if (!responseData?.leaderboards?.length) {
        return;
    }
    const userIds = [];
    responseData.leaderboards.forEach((item) => {
        if (!item?.leaderboard?.length) {
            return;
        }
        item.leaderboard.forEach((leaderboardItem) => {
            userIds.push(leaderboardItem.userPk);
        });
    });
    yield fork(fetchProfileImageAndFrameSaga, userIds);
}

function* fetchProfileImageAndFrameSaga(userIds) {
    if (!userIds || !userIds.length) {
        return;
    }
    yield put(fetchMultipleUserSocialProfileImage(userIds));
}

export const socialGroupRideSagas = [
    takeEvery(FETCH_SOCIAL_GROUP_RIDE, fetchSocialGroupRide),
    takeEvery(DELETE_SOCIAL_GROUP_RIDE_USER_DATA, deleteSocialGroupRideUserData),
    takeEvery(FETCH_SOCIAL_GROUP_RIDE_COMPETITIONS, fetchAllCompetitions)
];
